import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Core components
import { TextButton, ContainedButton } from 'components/core/Button';
import Divider from 'components/core/Divider';
import Typography from 'components/core/Typography';
// Custom
import LoadingDisplayer from 'components/misc/LoadingDisplayer';
import ErrorsDisplayer from 'components/misc/ErrorsDisplayer';
import { BackTextButton } from 'components/buttons/TextButtons';

class FormTemplate extends React.Component {
  componentDidUpdate(prevProps) {
    // Check if enter key has been pressed
    const { enterPressed, onValidate } = this.props;
    const { enterPressed: prevEnterPressed } = prevProps;
    if (!prevEnterPressed && enterPressed) {
      onValidate();
    }
  }

  render() {
    const {
      withoutTitle, loading, title, subtitle, errors, additionalError, children, disableValidate, backPath, onValidate, onCancel,
    } = this.props;

    return (
      <div className="box box-default m-0">
        {!withoutTitle && title && (
          <div className="box-header box-title p-0 pt-2 px-3">
            <div className="d-flex flex-nowrap justify-content-between align-items-center">
              <div>
                {title}
                {subtitle && (
                  <Typography type="subtitle">{subtitle}</Typography>
                )}
              </div>
              <div className="d-flex align-items-end">
                <BackTextButton primary path={backPath} />
              </div>
            </div>
            <div className="pt-2">
              <Divider light />
            </div>
          </div>
        )}
        <LoadingDisplayer loading={!!loading}>
          <form autoComplete="off">
            <div className="p-3">
              <ErrorsDisplayer errors={errors} additionalError={additionalError} />
              { children }
            </div>
            <div className="box-header box-light-dark d-flex justify-content-end mt-2 px-3 py-2 right-spaced-buttons">
              <TextButton
                label={<LocalizedMessage id="button.cancel" />}
                onClick={onCancel}
              />
              <ContainedButton
                label={<LocalizedMessage id="button.validate" />}
                disabled={disableValidate}
                onClick={onValidate}
              />
            </div>
          </form>
        </LoadingDisplayer>
      </div>
    );
  }
}

FormTemplate.propTypes = {
  loading: PropTypes.bool,
  withoutTitle: PropTypes.bool,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  subtitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  errors: PropTypes.shape({
    global: PropTypes.string.isRequired,
  }),
  additionalError: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  disableValidate: PropTypes.bool,
  backPath: PropTypes.string,
  enterPressed: PropTypes.bool,
  onValidate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

FormTemplate.defaultProps = {
  loading: false,
  withoutTitle: false,
  title: null,
  subtitle: null,
  errors: null,
  additionalError: null,
  disableValidate: false,
  backPath: '',
  enterPressed: false,
};

module.exports = FormTemplate;



// WEBPACK FOOTER //
// ./components/templates/FormTemplate.js